import { useReportCurrency } from "@/profitability/currency";
import { summaryText } from "@/profitability/overview/share-summary";
import type { RecordObject } from "@/profitability/records/objects";
import { isProfit, useReviewSpec } from "@/profitability/review/review-spec";
import type { TemplatePeriod } from "./use-template-period";

/**
 * The period's review as Share sends it on: "Weekly GM tracker, Oct 12–18,
 * 2026" as the subject, and the figures, what stands out and what is still
 * open as the text, with a link back to the page.
 */
export const usePeriodShare = (
  name: string,
  period: TemplatePeriod,
  objects: RecordObject[],
) => {
  const spec = useReviewSpec();
  const currency = useReportCurrency();
  const label = period.label ?? "latest report";
  const work = spec.work
    ? objects.find((object) => object.dataset.id === spec.work)
    : undefined;
  return {
    subject: `${name}, ${label}`,
    text: () =>
      summaryText({
        title: name,
        period: label,
        figures: period.overview.data?.figures ?? [],
        insights: period.overview.data?.insights ?? [],
        findings:
          period.findings.data?.pages.flatMap((page) => page.findings) ?? [],
        noun: work?.name.toLowerCase() ?? "record",
        plural: work?.plural.toLowerCase() ?? "records",
        profit: isProfit(spec),
        currency,
        link: window.location.href,
      }),
  };
};
